import { useState } from 'react'
import ReactGA from 'react-ga4'
import ReactHowler from 'react-howler'
export const AllCharacteres = () => {
    const [hover, setHover] = useState(false)
    const [isVoiceOn, setIsVoiceOn] = useState(false)

    const [voice, setVoice] = useState(1)
    const setCurrent = (e) => {
        setVoice(e)
    }
    const [showModal, setShowModal] = useState(false)
    const [activeCharTab, setActiveCharTab] = useState('characters')
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }

    const chardata = [
        {
            name: 'Marona',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        Fillette aux mystérieux pouvoirs, qui lui permettent de communiquer avec l'âme des défunts, les
                        « <span className='text-pborange'>fantômes</span> ». Autrefois surnommée «{' '}
                        <span className='text-pborange'>la Possédée</span> », elle est considérée comme{' '}
                        <span className='text-pborange'>la sauveuse du monde</span> après sa victoire face à Sulphur.
                        D'un caractère positif et radieux, elle s'applique quotidiennement en tant que{' '}
                        <span className='text-pborange'>Chroma</span> à répondre aux attentes des gens dans le besoin.
                    </p>{' '}
                </>
            ),
            caption: (
                <p className={`font-humming text-shadow-white font-bold text-[#57912c] text-sm md:text-lg -rotate-6`}>
                    Par le pouvoir miraculeux de la « Chartreuse » !
                </p>
            ),
            color: '#57912c',
        },
        {
            name: 'Ash',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        <span className='text-pborange'>Compagnon de route de Marona</span>, toujours à ses côtés depuis
                        qu'elle a perdu ses parents lorsqu'elle était plus jeune. Garçon droit, juste et gentil.{' '}
                        <span className='text-pborange'>Il se retrouve séparé de Marona</span> en tentant de la protéger
                        de l'attaque d'une mystérieuse flotte de bateaux fantômes.
                    </p>{' '}
                </>
            ),
            caption: (
                <p className={`font-humming text-shadow-white font-bold text-[#192f57] text-sub md:text-lg -rotate-6`}>
                    Je te protégerai coûte que coûte ! Pouvoir du Dragon aquatile « Écarlate » !
                </p>
            ),

            color: '#192f57',
        },
        {
            name: 'Abricot',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        <span className='text-pborange'>Petite fille fantôme</span> que Marona rencontre sur l'île du
                        Squelette sur laquelle elle échoue. Elle sait manier avec brio l'épée, comme son père, un ancien
                        héros pirate, lui a autrefois appris, mais n'a pas eu l'occasion de parler avec qui que ce soit
                        durant des années, ce qui la rend <span className='text-pborange'>très timide</span>. Elle
                        décide de se joindre à Marona pour partir à{' '}
                        <span className='text-pborange'>la recherche de son papa et reformer son équipage</span>.
                    </p>{' '}
                </>
            ),
            caption: (
                <p className={`font-humming text-shadow-white font-bold text-[#c22b52] text-sm md:text-lg -rotate-6`}>
                    Je vous en prie, aidez-moi !!
                </p>
            ),
            color: '#c22b52',
        },
        {
            name: 'Rouen',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        Homme-bête qui était autrefois{' '}
                        <span className='text-pborange'>premier-lieutenant des pirates d'Argento et bras droit</span> du
                        père d'Abricot, le leader de la flotte. Bien qu'il se donne toujours des airs apathiques et
                        nihilistes, <span className='text-pborange'>c'est en fait un brave type</span>. Il fait preuve
                        d'une attitude parentale presque surprotectrice à l'égard d'Abricot, qu'il surnomme « Princesse
                        », ce qui ne l'empêche pas de lui envoyer quelques piques tout en prenant soin d'elle.
                    </p>{' '}
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        Cinq ans avant les événements du jeu, il a essayé en vain de protéger Abricot et ses compagnons
                        lors de leur confrontation avec les Naufrageurs. C'est ainsi qu'ils ont perdu la vie.
                    </p>
                </>
            ),
            caption: (
                <p className={`font-humming text-shadow-white font-bold text-[#4879a6] text-sub md:text-lg -rotate-6`}>
                    Tss... Tu parles d'une bande de pirates...
                </p>
            ),

            color: '#4879a6',
        },
        {
            name: 'Henna',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        Fantôme d'une <span className='text-pborange'>ancienne souveraine</span> du royaume de Hasara,
                        île recouverte à 70 % de sable. Depuis des temps immémoriaux, il est de coutume à Hasara qu'une
                        femme dirige le pays. Cependant, alors qu'elle était encore jeune et inexpérimentée, elle prit
                        de <span className='text-pborange'>mauvaises décisions politiques</span> qui entraînèrent un{' '}
                        <span className='text-pborange'>coup d'État</span> au cours duquel elle perdit la vie. Elle est
                        par la suite réapparue au royaume de Hasara sous forme de fantôme. Par son pouvoir ensorcelant,
                        elle transforme ses infortunées victimes en serviteurs. Elle s'oppose à la reine actuelle, sa
                        jeune sœur biologique.
                    </p>
                </>
            ),
            caption: (
                <p className={`font-humming text-shadow-white font-bold text-[#7b5f1b] text-sub md:text-lg -rotate-6`}>
                    Je vais m'emparer de vos âmes et de vos vies ! Par mon pouvoir de Charme... « Opéra Mauve » !
                </p>
            ),

            color: '#7b5f1b',
        },
        {
            name: 'Urumi',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        Garçon fantôme qui vit sur l'île aux Flocons, lieu recouvert de neige toute l'année, et où règne
                        un froid extrême. Depuis son décès, il y a bien des années, alors qu'il n'était encore qu'un
                        jeune garçon,{' '}
                        <span className='text-pborange'>
                            il a acquis la capacité de se manifester et de contrôler le climat autour de lui
                        </span>
                        . Malgré son apparence juvénile, il est extrêmement puissant et a déjà fait de nombreuses
                        victimes en détériorant le climat. Voilà pourquoi les habitants de l'île le qualifient de «{' '}
                        <span className='text-pborange'>diable</span> » et le craignent.
                    </p>{' '}
                </>
            ),
            caption: (
                <p className={`font-humming text-shadow-white font-bold text-[#787985] text-sm md:text-lg -rotate-6`}>
                    Transforme-toi en glace... ! Gelez ! Gelez !! Je veux tous vous voir congelés !
                </p>
            ),

            color: '#787985',
        },
        {
            name: 'Mayfair',
            bio: (
                <>
                    <p className='font-kiwi text-pbbrown text-shadow-white font-bold text-sm md:text-base'>
                        <span className='text-pborange'>
                            Leader d'un certain groupe de pirates, qui la considèrent un peu comme une grande sœur
                        </span>
                        . Elle apparaît au cours de l'aventure de Marona lorsque celle-ci et ses compagnons se rendent à
                        Versailles, île luxuriante fermée aux étrangers, qu'elle protège contre les braconniers. Dès
                        qu'elle prend une résolution, elle fonce tête baissée. À ses yeux,{' '}
                        <span className='text-pborange'>la fanfaronnade et la famille </span>
                        passent avant tout le reste. Considérant son équipage comme sa famille, elle se comporte tantôt
                        en sévère préceptrice, tantôt en douce protectrice.
                    </p>
                </>
            ),
            caption: (
                <p
                    className={`font-humming text-shadow-white font-bold text-[#B12A57] text-sub md:text-MayfairCaption -translate-y-1/2 md:-translate-y-full -rotate-6`}
                >
                    Je considère mes matelots comme ma propre famille. Jamais un capitaine digne de ce nom ne s'en
                    prendrait aux sauveurs de sa propre famille !
                </p>
            ),

            color: '#B12A57',
        },
    ]
    return (
        <div className='pt-4 '>
            {isVoiceOn && (
                <ReactHowler
                    src={`${process.env.PUBLIC_URL}/voice/main_0${voice}.mp3`}
                    playing={isVoiceOn}
                    volume={0.3}
                    loop={false}
                    onEnd={() => setIsVoiceOn(false)}
                />
            )}
            <div className='w-full max-w-[1136px] mx-auto px-2'>
                <div className='relative mx-auto h-0 w-full pt-[58.8%]'>
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Marona',
                            })
                        }}
                        href='#char-1'
                    >
                        <img
                            onMouseEnter={() => setHover(1)}
                            onMouseLeave={() => setHover(false)}
                            className='char1 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_01.png`}
                            alt='marona kv'
                        />{' '}
                    </a>
                    {hover === 1 && (
                        <img
                            className='hidden md:block charinfo-1'
                            src={`${process.env.PUBLIC_URL}/images/characters/marona-name.png`}
                            alt='comment bubble'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-1'
                        src={`${process.env.PUBLIC_URL}/images/characters/marona-name.png`}
                        alt='comment bubble'
                    />

                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Ash',
                            })
                        }}
                        href='#char-2'
                    >
                        <img
                            onMouseEnter={() => setHover(2)}
                            onMouseLeave={() => setHover(false)}
                            className='char2 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_02.png`}
                            alt='ash kv'
                        />{' '}
                    </a>
                    {hover === 2 && (
                        <img
                            className='hidden md:block charinfo-2'
                            src={`${process.env.PUBLIC_URL}/images/characters/ash-name.png`}
                            alt='comment bubble'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-2'
                        src={`${process.env.PUBLIC_URL}/images/characters/ash-name.png`}
                        alt='comment bubble'
                    />

                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Apricot',
                            })
                        }}
                        href='#char-3'
                    >
                        <img
                            onMouseEnter={() => setHover(3)}
                            onMouseLeave={() => setHover(false)}
                            className='char3 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_03.png`}
                            alt='apricot kv'
                        />
                    </a>
                    {hover === 3 && (
                        <img
                            className='hidden md:block charinfo-3'
                            src={`${process.env.PUBLIC_URL}/images/characters/apricot-name-fr.png`}
                            alt='comment bubble'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-3'
                        src={`${process.env.PUBLIC_URL}/images/characters/apricot-name-fr.png`}
                        alt='comment bubble'
                    />
                </div>{' '}
            </div>
            <img
                className='mx-auto my-12'
                src={`${process.env.PUBLIC_URL}/images/characters/character-header-fr.png`}
                alt='comment bubble'
            />
            <div className='max-w-[1258px] w-full mx-auto px-4'>
                <div className='relative mx-auto h-0 w-full pt-[62.480127186%]'>
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Rouen',
                            })
                        }}
                        href='#char-4'
                    >
                        <img
                            onMouseEnter={() => setHover(4)}
                            onMouseLeave={() => setHover(false)}
                            className='char4 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_04.png`}
                            alt='apricot kv'
                        />
                    </a>
                    {hover === 4 && (
                        <img
                            className='hidden md:block charinfo-4'
                            src={`${process.env.PUBLIC_URL}/images/characters/rouen-name.webp`}
                            alt='rouen'
                        />
                    )}
                    <img
                        className='block md:hidden charinfo-4'
                        src={`${process.env.PUBLIC_URL}/images/characters/rouen-name.webp`}
                        alt='rouen'
                    />
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Henna',
                            })
                        }}
                        href='#char-5'
                    >
                        <img
                            onMouseEnter={() => setHover(5)}
                            onMouseLeave={() => setHover(false)}
                            className='char5 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_05.png`}
                            alt='apricot kv'
                        />
                    </a>
                    {hover === 5 && (
                        <img
                            className='hidden md:block charinfo-5'
                            src={`${process.env.PUBLIC_URL}/images/characters/henna-name.png`}
                            alt='henna'
                        />
                    )}{' '}
                    <img
                        className='block md:hidden charinfo-5'
                        src={`${process.env.PUBLIC_URL}/images/characters/henna-name.png`}
                        alt='henna'
                    />
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Urumi',
                            })
                        }}
                        href='#char-6'
                    >
                        <img
                            onMouseEnter={() => setHover(6)}
                            onMouseLeave={() => setHover(false)}
                            className='char6 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_06.png`}
                            alt='urumi'
                        />
                    </a>
                    {hover === 6 && (
                        <img
                            className='hidden md:block charinfo-6'
                            src={`${process.env.PUBLIC_URL}/images/characters/urumi-name.webp`}
                            alt='urumi'
                        />
                    )}{' '}
                    <img
                        className='block md:hidden charinfo-6'
                        src={`${process.env.PUBLIC_URL}/images/characters/urumi-name.webp`}
                        alt='urumi'
                    />
                    <a
                        onClick={() => {
                            ReactGA.event({
                                action: 'click',
                                event: 'link',
                                category: 'Character',
                                label: 'Mayfair',
                            })
                        }}
                        href='#char-7'
                    >
                        <img
                            onMouseEnter={() => setHover(7)}
                            onMouseLeave={() => setHover(false)}
                            className='char7 hover:brightness-110 duration-300 cursor-pointer'
                            src={`${process.env.PUBLIC_URL}/images/characters/chr_nav_visual_07.png`}
                            alt='mayfair'
                        />
                    </a>
                    {hover === 7 && (
                        <img
                            className='charinfo-7'
                            src={`${process.env.PUBLIC_URL}/images/characters/mayfair-name.png`}
                            alt='mayfair'
                        />
                    )}{' '}
                    <img
                        className='block md:hidden charinfo-7'
                        src={`${process.env.PUBLIC_URL}/images/characters/mayfair-name.png`}
                        alt='mayfair'
                    />
                </div>{' '}
            </div>
            {chardata.map((chardata, i) => (
                <section id={`char-${i + 1}`} className='bg-char overflow-hidden'>
                    <div className='max-w-[1280px] lg:w-[80vw] flex flex-col align-middle md:flex-row md:items-end relative pt-8 mx-auto '>
                        <div className='w-full md:w-1/2 lg:w-[60%] mx-auto z-10'>
                            <div className='w-full md:w-4/5 mx-auto md:pt-12 '>
                                <div className='text-center'>
                                    <span className={`relative  inline-block`}>
                                        <img
                                            className='max-w-full mx-auto text-center px-2 md:px-0'
                                            src={`${process.env.PUBLIC_URL}/images/characters/char-name-0${
                                                i + 1
                                            }-fr.png`}
                                            alt={chardata.name}
                                        />{' '}
                                    </span>{' '}
                                </div>
                                <div className='text-center md:text-left md:pt-12 flex flex-col md:flex-row justify-center  px-4 md:px-0 relative w-full mx-auto'>
                                    <div className={`character-description-0${i + 1} relative mb-12`}>
                                        {chardata.bio}

                                        <img
                                            onClick={() => {
                                                handleOpenModal(i + 1)
                                            }}
                                            className='mt-8 ss-thumb w-full max-w-[500px]'
                                            src={`${process.env.PUBLIC_URL}/images/ss/ss-char-${i + 1}-s.webp`}
                                            alt='game screenshot'
                                        />
                                    </div>
                                </div>{' '}
                            </div>
                        </div>{' '}
                        <div
                            className={`w-full md:w-1/2 lg:w-[40%] character-visual char-translate-y-${
                                i + 1
                            }   md:translate-y-0`}
                        >
                            <picture className={`character-bustup0${i + 1} bottom-0 `}>
                                <source
                                    srcSet={`${process.env.PUBLIC_URL}/images/characters/chr_visual_0${i + 1}_sp.png`}
                                    media='(max-width: 768px)'
                                ></source>
                                <img
                                    className=''
                                    src={`${process.env.PUBLIC_URL}/images/characters/chr_visual_0${i + 1}.png`}
                                    alt={chardata.name}
                                />{' '}
                            </picture>
                            <div>
                                <div className='absolute top-0 -translate-y-1/4 lg:-translate-y-1/4 left-1/2 -translate-x-1/2 w-4/5 lg:w-full text-center mx-auto'>
                                    {chardata.caption}
                                </div>

                                {voice === i + 1 && isVoiceOn === true ? (
                                    <button
                                        onClick={() => {
                                            setIsVoiceOn(false)
                                        }}
                                        className='w-auto absolute right-[10vw] lg:right-0 bottom-[20%] md:bottom-8 lg:bottom-28'
                                    >
                                        <img
                                            className='w-[7vw] md:w-full  mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/btn_voice_off.png`}
                                            alt='voice off mark'
                                        />{' '}
                                    </button>
                                ) : (
                                    <button
                                        onClick={() => {
                                            setCurrent(i + 1)
                                            setIsVoiceOn(true)
                                        }}
                                        className='w-auto absolute right-[10vw] lg:right-0 bottom-[20%] md:bottom-8 lg:bottom-28'
                                    >
                                        <img
                                            className='w-[7vw] md:w-full mx-auto'
                                            src={`${process.env.PUBLIC_URL}/images/btn_voice.png`}
                                            alt='voice mark'
                                        />{' '}
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            ))}
            <div
                onClick={handleCloseModal}
                className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='w-full md:w-[80%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 mx-auto z-30'
                >
                    <div className='flex flex-row items-center max-w-[1920px] mx-auto px-4 md:px-0 md:gap-4'>
                        <div className='relative'>
                            <button
                                onClick={handleCloseModal}
                                className='absolute top-0 right-16 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                            >
                                <img
                                    className=''
                                    src={`${process.env.PUBLIC_URL}/images/close.png`}
                                    alt={`screen shot of game system`}
                                />{' '}
                            </button>
                            <img
                                className='white-drop-shadow max-w-[1920px] mx-auto w-full'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-char-${modalImage}.webp`}
                                alt={`screen shot of game system`}
                            />{' '}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
